import { AppError } from './AppError';
import type { ErrorKind, ErrorTier } from './types';

/** Bug, infrastructure outage, or anything unexpected. Always our fault — the
 *  only tier that masks its message in prod, turns Tempo spans red, and pages oncall. */
export class SystemError extends AppError {
  readonly kind: ErrorKind = 'system';
  readonly tier: ErrorTier = 'system';
  protected defaultRetryable(): boolean {
    return true;
  }
}
